import { Controller } from "stimulus";
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = ['section', 'inputs']
  static values = { formObjectName: String, sortable: Boolean };

  connect() {
    const defaultInputs =  this.inputsTarget.querySelectorAll('input, select')

    Array.from(defaultInputs).forEach(defaultInput => {
      defaultInput.disabled = true
    });

    if (this.sortableValue) {
      this.sortable = Sortable.create(this.sectionTarget, {
        handle: '.array-field-drag-handle',
        animation: 150,
        onEnd: () => this.reindex(),
      });
    }
  }

  addField() {
    var inputs_clone = this.inputsTarget.children[0].cloneNode(true);

    Array.from(inputs_clone.querySelectorAll('input, select')).forEach(clonedInput => {
      clonedInput.disabled = false;
      clonedInput.name = `${this.formObjectNameValue}[${this.sectionTarget.children.length + 1}]${clonedInput.name.replace(`${this.formObjectNameValue}`, '' )}`
      clonedInput.id = `${clonedInput.id}_${this.sectionTarget.children.length + 1}`
    });
    
    this.sectionTarget.appendChild(inputs_clone);
  }

  removeField(event) {
    const field = event.target.closest("button").parentElement
    
    field.remove()
    if (this.sortableValue) this.reindex()
  }

  reindex() {
    Array.from(this.sectionTarget.children).forEach((item, i) => {
      const newIndex = i + 1;
      item.querySelectorAll('input, select').forEach((input) => {
        if (input.name) {
          input.name = input.name.replace(/\[(\d+)\](\[.+\])$/, `[${newIndex}]$2`);
        }
      });
    });
  }
}